import { ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

export default function useAllotEdit(getList) {
  // 编辑组件ref
  const adjustRef = ref(null);

  // 点击新增或详情
  const handleAdjust = (row, type) => {
    adjustRef.value?.handleDialogOpen({ row, type });
  };

  // 点击删除
  const handleDelete = (ids) => {
    ElMessageBox.confirm("确定删除所选数据吗？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        getList();
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };
  return {
    adjustRef,
    handleAdjust,
    handleDelete,
  };
}
